import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../theme';

export const StyledCategory = styled.div`
  border-top: 1px solid ${color('midnight_200')};
`;

export const StyledTrigger = styled.button<{ ariaExpanded?: boolean }>`
  padding: ${spacing('md')};
  background-color: unset;
  border: unset;
  text-align: left;
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing('md')};
  cursor: pointer;
  color: ${'midnight_800'};
  -webkit-appearance: none;

  @media (min-width: ${screen('md')}) {
    padding: ${spacing('md')} 2.5rem;
  }

  h2 {
    margin: 0;
    font-size: ${fontSize('lg')};
    line-height: 1;
    transition: 0.3s;
    font-family: ${fontFamily('display')};
    font-size: ${fontSize('xl2')};
    font-weight: ${fontWeight('light')};
    text-transform: uppercase;

    @media (min-width: ${screen('md')}) {
      font-size: ${fontSize('xl3')};
    }
  }

  &.is-active {
    svg {
      transform: rotate(180deg);
    }
  }

  &:hover {
    transition: 0.3s;
    h2 {
      color: ${color('text_subtle')};
    }
  }
  &:focus-visible {
    outline: ${spacing('xs2')} solid ${color('midnight_150')};
  }
`;

export const StyledIcon = styled.img`
  display: block;
  width: ${spacing('xl')};
  height: auto;

  @media (max-width: ${screen('mdMax')}) {
    display: none;
  }
`;

export const StyledCaret = styled.div`
  margin-left: auto;
  margin-right: -5px;

  svg {
    width: ${spacing('md')} !important;
    height: ${spacing('md')};
  }
`;

export const StyledContent = styled.div`
  overflow: hidden;
  margin: 0;
  transition: max-height 0.3s ease-in-out;
  max-height: 0;

  &.is-active {
    max-height: var(--content-height);
  }

  dl {
    padding: ${spacing('xs2')} 1.25rem;
    margin: 0;

    @media (min-width: ${screen('md')}) {
      padding: ${spacing('md')} 2.5rem 0;
    }

    > :first-child dt:first-child {
      border-top: 0;
    }
  }
`;
